import CallServer from '../../api/CallServerV2';

export async function fetchGetFolder (params = {}) {
    return await CallServer({
        endpoint: '/admin/get_folder',
        params: params,
        needAuthenticate: true,
        isGet: true,
        retryIfFailed: true
    })
} 

export async function fetchGetSubFolders (params = {}) {
    return await CallServer({
        endpoint: '/admin/get_subfolders_by_parent_folder_id',
        params: params,
        needAuthenticate: true,
        isGet: true,
        retryIfFailed: true
    })
} 

export async function fetchGetVideo (params = {}) {
    return await CallServer({
        endpoint: '/get_video',
        params: params,
        needAuthenticate: true,
        isGet: true,
        retryIfFailed: true
    })
} 

export async function fetchAddLink (params = {}, linkData) {
    return await CallServer({
        endpoint: '/admin/add_links_to_folder',
        params: params,
        needAuthenticate: true,
        body: linkData,
        retryIfFailed: true
    })
}

export async function fetchAddVideosToFolder (params = {}, videosData) {
    return await CallServer({
        endpoint: '/admin/add_videos_to_folder',
        params: params,
        needAuthenticate: true,
        body: videosData,
        retryIfFailed: true
    })
}

export async function fetchCreateNewFolder (folderData) {
    return await CallServer({
        endpoint: '/admin/create_new_folder',
        needAuthenticate: true,
        body: folderData,
        retryIfFailed: true
    })
} 

export async function fetchEditFolder (params = {}, folderData) {
    return await CallServer({
        endpoint: '/admin/edit_folder',
        params: params,
        needAuthenticate: true,
        body: folderData,
        retryIfFailed: true
    })
} 

export async function fetchCopyFolder (params = {}) {
    return await CallServer({
        endpoint: '/admin/copy_folder',
        params: params,
        needAuthenticate: true,
    })
}

export async function fetchEditFoldersPriorities (foldersPriorities) {
    return await CallServer({
        endpoint: '/admin/edit_folders_priorities',
        needAuthenticate: true,
        body: foldersPriorities,
    })
}

export async function fetchAddFilesToFolder (params = {}, files) {
    return await CallServer({
        endpoint: '/admin/add_files_to_folder',
        params: params,
        needAuthenticate: true,
        body: files,
    })
}
